import { Phone, MapPin, Clock } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer className="py-16 md:py-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* CTA Banner */}
        <motion.div
          className="bg-card border border-amber-500/20 rounded-3xl p-8 md:p-14 text-center mb-16 shadow-2xl relative overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-amber-500/5 rounded-full blur-[100px] pointer-events-none" />
          <div className="relative">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
              Besoin d'un départ immédiat ?
            </h2>
            <p className="text-zinc-400 mb-8 text-base md:text-lg max-w-md mx-auto">
              Nous sommes disponibles 24h/24 et 7j/7 pour répondre à vos besoins urgents ou planifiés.
            </p>
            <motion.a
              href="tel:0652620747"
              className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-400 text-black font-bold uppercase tracking-wider px-10 py-5 rounded-full shadow-[0_0_30px_rgba(245,158,11,0.3)] transition-all duration-300 text-base"
              whileHover={{ scale: 1.03, boxShadow: "0 0 40px rgba(245,158,11,0.5)" }}
              whileTap={{ scale: 0.98 }}
              data-testid="footer-call-btn"
            >
              <Phone className="h-5 w-5" />
              Appeler le 06 52 62 07 47
            </motion.a>
          </div>
        </motion.div>

        <Separator className="bg-white/10 mb-12" />

        {/* Footer Info */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          <div>
            <h3 className="text-gold-gradient text-2xl font-bold mb-2">RSE TAXI</h3>
            <p className="font-tagline text-sm tracking-[0.2em] uppercase text-amber-400/70">
              Rapide &bull; Simple &bull; Efficace
            </p>
            <p className="text-zinc-500 text-sm mt-3">
              Taxi conventionné CPAM &mdash; Nord de Toulouse
            </p>
          </div>

          <div className="flex flex-col items-center md:items-start gap-3">
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <MapPin className="h-4 w-4 text-amber-400 flex-shrink-0" />
              Base : Launaguet (31140) &mdash; Zone 31
            </div>
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <Phone className="h-4 w-4 text-amber-400 flex-shrink-0" />
              <a href="tel:0652620747" className="hover:text-amber-400 transition-colors">
                06 52 62 07 47
              </a>
            </div>
            <div className="flex items-center gap-2 text-zinc-400 text-sm">
              <Clock className="h-4 w-4 text-amber-400 flex-shrink-0" />
              Disponible 24h/24 &mdash; 7j/7
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start gap-2">
            <span className="text-zinc-400 text-sm font-semibold">Services :</span>
            <span className="text-zinc-500 text-sm">Transport Médical VSL (CPAM)</span>
            <span className="text-zinc-500 text-sm">Courses Professionnelles</span>
            <span className="text-zinc-500 text-sm">Courses Privées</span>
          </div>
        </div>

        <Separator className="bg-white/10 mt-12 mb-6" />

        <p className="text-center text-zinc-600 text-xs">
          &copy; {new Date().getFullYear()} RSE TAXI &mdash; Tous droits réservés
        </p>
      </div>
    </footer>
  );
}
